import script from "./TradeTrackerTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TradeTrackerTable.vue?vue&type=script&setup=true&lang=js"

import "./TradeTrackerTable.vue?vue&type=style&index=0&id=fc6d8f88&lang=scss"

const __exports__ = script;

export default __exports__